function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgOper = function SvgOper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("path", {
    style: {
      fill: "#5A4146"
    },
    d: "M423.683,315.569c0.052,7.011-4.099,13.325-10.46,16.275c-40.022,18.564-95.66,30.088-157.224,30.088 s-117.202-11.523-157.225-30.088c-6.36-2.951-10.511-9.265-10.46-16.275C89.57,147.062,120.395,0,256,0 S422.43,147.062,423.683,315.569z"
  }), React.createElement("path", {
    style: {
      fill: "#E6AF78"
    },
    d: "M317.793,342.844v-42.706H194.207v42.706c0,11.399-7.294,21.519-18.109,25.123l-84.126,28.042 c-18.023,6.008-30.179,22.875-30.179,41.873v56.463c0,9.751,7.904,17.655,17.655,17.655h353.103c9.751,0,17.655-7.904,17.655-17.655 v-56.463c0-18.998-12.157-35.865-30.18-41.873l-84.126-28.042C325.087,364.362,317.793,354.242,317.793,342.844z"
  }), React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M194.207,342.844c0,10.685-6.453,20.173-16.161,24.298c98.92,16.858,139.72-53.762,139.72-53.762 l0.028-0.019v-13.223H194.207V342.844z"
  }), React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M420.026,396.009l-68.74-22.913c-32.717,44.385-70.904,69.187-95.286,77.111 c-24.382-7.924-62.569-32.726-95.286-77.111l-68.74,22.913c-18.024,6.008-30.18,22.875-30.18,41.873v56.463 c0,9.75,7.905,17.655,17.655,17.655h353.103c9.75,0,17.655-7.905,17.655-17.655v-56.463 C450.207,418.883,438.05,402.017,420.026,396.009z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#D7DEED"
    },
    d: "M122.071,457.519l-48.97-48.97c-7.06,7.908-11.308,18.219-11.308,29.332v56.463 c0,9.751,7.904,17.655,17.655,17.655h52.966v-29.512C132.414,473.123,128.694,464.142,122.071,457.519z"
  }), React.createElement("path", {
    style: {
      fill: "#D7DEED"
    },
    d: "M389.929,457.519l48.97-48.97c7.06,7.908,11.308,18.219,11.308,29.332v56.463 c0,9.751-7.904,17.655-17.655,17.655h-52.966v-29.512C379.586,473.123,383.306,464.142,389.929,457.519z"
  }), React.createElement("path", {
    style: {
      fill: "#D7DEED"
    },
    d: "M146.505,383.569c35.457,48.108,76.991,74.643,104.039,83.431L256,468.77l5.457-1.771 c27.048-8.789,68.582-35.324,104.039-83.431l3.166-4.682l-17.376-5.792c-32.716,44.386-70.903,69.188-95.285,77.112 c-24.382-7.924-62.569-32.726-95.286-77.111l-17.376,5.792L146.505,383.569z"
  })), React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M142.72,185.469l-10.251-0.033c-9.772-0.031-17.711,7.883-17.711,17.655v34.899 c0,9.888,8.12,17.848,18.007,17.652l15.215-0.303L142.72,185.469z"
  }), React.createElement("path", {
    style: {
      fill: "#65687A"
    },
    d: "M132.47,185.436c-0.02,0-0.036,0.006-0.056,0.006v70.172c0.119,0,0.232,0.031,0.352,0.029 l15.215-0.303l-5.26-69.869L132.47,185.436z"
  }), React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M369.28,185.469l10.251-0.033c9.772-0.031,17.711,7.883,17.711,17.655v34.899 c0,9.888-8.12,17.848-18.007,17.652l-15.215-0.303L369.28,185.469z"
  }), React.createElement("path", {
    style: {
      fill: "#65687A"
    },
    d: "M379.53,185.436c0.02,0,0.036,0.006,0.056,0.006v70.172c-0.119,0-0.232,0.031-0.352,0.029 l-15.215-0.303l5.26-69.869L379.53,185.436z"
  }), React.createElement("path", {
    style: {
      fill: "#F0C087"
    },
    d: "M141.241,105.931v38.061c0,15.816,0.607,31.625,1.82,47.393l5.087,66.129 c1.216,15.807,9.448,30.238,22.435,39.329l53.308,37.315c9.407,6.585,20.612,10.118,32.095,10.118h0.026 c11.482,0,22.688-3.532,32.095-10.118l53.308-37.315c12.988-9.091,21.22-23.522,22.435-39.329l5.087-66.129 c1.213-15.768,1.82-31.578,1.82-47.393v-38.061H141.241z"
  }), React.createElement("path", {
    style: {
      fill: "#E6AF78"
    },
    d: "M370.097,105.931H141.241v38.063c0,4.905,0.166,9.806,0.282,14.709l0,0v0.003 c0.14,5.895,0.364,11.785,0.673,17.673c0,0.001,0,0.003,0,0.003v0.001c0.263,5.002,0.481,10.006,0.865,15.001l5.087,66.129 c1.216,15.807,9.448,30.238,22.436,39.329l53.308,37.315c9.407,6.584,20.612,10.116,32.095,10.116 c-14.166,0-29.735-24.384-39.503-42.876c-6.435-12.181-9.869-25.684-10.126-39.458l-1.491-79.928 c-0.118-6.356,4.487-11.763,10.75-12.85c47.34-8.216,84.919-21.641,106.401-31.126c17.03,28.15,39.46,36.57,42.368,37.564 l2.777,0.949h2.631c0.31-5.882,0.536-11.766,0.679-17.655L370.097,105.931z"
  }), React.createElement("path", {
    style: {
      fill: "#5A4146"
    },
    d: "M132.414,97.103v61.793c104.585,0,184.198-36.41,197.532-44.455 c14.33,35.627,40.151,44.455,40.151,44.455h9.49V97.103H132.414z"
  }), React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M379.234,255.641l-15.147-0.301c-6.74,12.245-26.929,32.295-87.123,32.295v17.655 c80.439,0,101.08-34.278,106.324-50.073C381.98,255.496,380.632,255.669,379.234,255.641z"
  }), React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M269.241,308.966h-8.828c-7.313,0-13.241-5.929-13.241-13.241l0,0 c0-7.313,5.929-13.241,13.241-13.241h8.828c7.313,0,13.241,5.929,13.241,13.241l0,0 C282.483,303.037,276.554,308.966,269.241,308.966z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/oper.82ff9446.svg";
export { ForwardRef as ReactComponent };